<template>
  <div style="height: 100vh; width: 100%">
    <div style="width: 100%; display: none; height: 0%">
      <img id="imageid" :src="profpic" />
      <canvas id="imgCanvas" />
      <pdf-make
        ref="pdfMake"
        style="width: 100%"
        :content="content"
        :pageSize="'A4'"
        :pageOrientation="'portrait'"
        :show="true"
        :info="{ title: title }"
        @change="
          (e) => {
            src = e;
          }
        "
      >
      </pdf-make>
    </div>
    <iframe
      id="content-frame"
      :src="src"
      style="width: 100%; display: inline-block; height: 100%"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import PdfMake from "@/components/PdfMake";
import { docContent } from "@/data/TemplatePersetujuan.js";
import { headerImage } from "@/data/headerImage.js";
import { labelValueFormatter } from "@/data/helper.js";
// import ttf from 'url-loader!@/assets/微软雅黑.ttf'
//console.log(ttf)
export default {
  name: "DocPersetujuan",
  components: {
    PdfMake,
  },
  data() {
    return {
      title: "Surat Persetujuan",
      src: "",
      content: [],
      ralan: {},
      profpic: "https://103.27.207.58/backend/public/images/icon_customer.png",
    };
  },
  methods: {
    executeDocument: function() {
      document.getElementById("content-frame").contentWindow.window.print();
    },
    toDataUrl: function(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.ralan = JSON.parse(
      this.CryptoJS.AES.decrypt(
        this.$route.params.slug.replace(/fRWdSl45h/g, "/"),
        this.$store.state.simrsSecretPassphrase
      ).toString(this.CryptoJS.enc.Utf8)
    );
    this.content = docContent;
    var draft = {
      title: "SURAT PERNYATAAN",
      subtitle: "",
      intro: ``,
      p1: `Yang bertanda tangan dibawah ini :`,
      arr1: [
        {
          label: "Nama Lengkap",
          value: "________________________________________(L/P)",
        },
        {
          label: "Tempat/Tanggal Lahir",
          value: "________________________________________",
        },
        { label: "Alamat", value: "________________________________________" },
        {
          label: "Nomor Telepon",
          value: "________________________________________",
        },
      ],
      p2: `Dengan ini menyatakan dengan sesungguhnya telah memberikan persetujuan untuk dilakukan tindakan operasi dengan pembiusan terhadap:`,
      arr2: [
        {
          label: "Nama Lengkap",
          value: `${this.ralan.pasien.nama} (${this.ralan.pasien.jen_kelamin})`,
        },
        {
          label: "Tempat / Tanggal Lahir (Usia)",
          value: this.ralan.pasien.formatted_tempat_tgl_lahir,
        },
        { label: "Alamat", value: this.ralan.pasien.alamat },
        { label: "Nomor Telepon", value: this.ralan.pasien.no_telp },
        { label: "No. Rekam Medis", value: this.ralan.pasien.no_rm },
      ],
      p3: `Peryataan ini saya buat dengan sesungguhnya bahwa :
1. Saya telah diberikan penjelasan oleh dokter mengenai mengapa tindakan medis diperlukan, juga akan bahaya, resiko serta kemungkinan-kemungkinan yang dapat timbul sebagai akibat tindakan medis tersebut.
2. Saya yakin bahwa dokter yang melakukan tindakan medis ini akan melakukan tindakan tersebut sebaik-baiknya sesuai dengan pengetahuan dan keterampilan yang dimilikinya dan menghindarkan terjadinya hal-hal yang tidak diinginkan. Walaupun demikian, hal-hal di luar dugaan dapat saja terjadi
3. Saya juga menyetujui bila saat dilakukan tindakan medis ini dan dokter menilai perlu dilakukan tindakan medis lebih lanjut semata-mata demi kebaikan pasien.
4. Saya telah memahami sepenuhnya penjelasan yang diberikan dokter tersebut dan menerima resiko yang timbul akibat dari tindakan medis tersebut.`,
    };
    var sign = `Pekanbaru, ________________________

      Yang Membuat Pernyataan



      (________________________)`;
    let arr1 = labelValueFormatter(draft.arr1, 200);
    let arr2 = labelValueFormatter(draft.arr2, 200);
    this.content = [
      {
        image: headerImage,
        width: 529,
      },
      {
        text: draft.title,
        style: "titleOnly",
      },
      {
        style: "paragraph",
        text: draft.intro,
      },
      {
        style: "paragraph",
        text: draft.p1,
      },
      ...arr1,
      {
        style: "paragraph",
        text: draft.p2,
      },
      ...arr2,
      {
        style: "paragraph",
        text: draft.p3,
      },
      {
        columns: [
          { text: "" },
          {
            style: "sign",
            text: sign,
          },
        ],
      },
    ];
  },
};
</script>
